import PropTypes from 'prop-types';
import React from 'react';

import { HtmlContentLoader, WysiwygStyleWrapper } from '@powdr/components';
import { ColorProfiles, Components, ScreenType } from '@powdr/constants';

import {
  ActiveTabTitle,
  ComponentIcon,
  ComponentIconWrapper,
  ComponentWrapper,
  CTAButton,
  CTAItem,
  CTAList,
  StyledActiveTab,
} from './styles';

export const ActiveTab = ({
  platform,
  icon = null,
  title = null,
  content = null,
  buttons = null,
  colorProfile = ColorProfiles.BASE,
  children,
}) => (
  <StyledActiveTab $colorProfile={colorProfile}>
    {platform === ScreenType.DESKTOP && (
    <ComponentIconWrapper>
      <ComponentIcon
        $colorProfile={colorProfile}
        name={icon}
        width="100"
        height="fit-content"
      />
    </ComponentIconWrapper>
    )}
    <ComponentWrapper
      $colorProfile={colorProfile}
    >
      {(title) && (
        <ActiveTabTitle
          $colorProfile={colorProfile}
        >
          {title}
        </ActiveTabTitle>
      )}
      {(content) && (
        <WysiwygStyleWrapper colorProfile={colorProfile} component={Components.COMPONENT_TABS}>
          <HtmlContentLoader html={content} allowRerender />
        </WysiwygStyleWrapper>
      )}
      {children}
      {(buttons) && (
        <CTAList>
          {buttons.map((buttonData) => {
            const {
              id, buttonLink, buttonTarget, buttonText,
            } = buttonData;

            return (
              <CTAItem key={id}>
                <CTAButton
                  $colorProfile={colorProfile}
                  href={buttonLink}
                  target={buttonTarget}
                >
                  {buttonText}
                </CTAButton>
              </CTAItem>
            );
          })}
        </CTAList>
      )}
    </ComponentWrapper>

  </StyledActiveTab>
);

ActiveTab.propTypes = {
  platform: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  colorProfile: PropTypes.string,
  children: PropTypes.node.isRequired,
};
